module.exports = __webpack_public_path__ + "static/media/notification.486c8d9f.svg";